import { type UseQueryResult, useQuery } from 'react-query';
import { RelationshipService } from '../../services/wealthlane-customer-services';

const useGetRelationship = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const RelationshipList = useQuery(
    ['getRelationshipListList'],
    async () => {
      return await handleRequest(
        RelationshipService.getApiCustomerApiAppRelationshipRelationshipList()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return RelationshipList;
};

export default useGetRelationship;
